exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#AddUser .v--modal-box.v--modal{min-height:200px!important;min-width:500px!important}#AddUser .v-input__slot,#AddUser .v-text-field__slot label{font-size:12px}#AddUser ul{list-style-type:disc;padding-left:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-81716116","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/settings/modals/userManagement/AddUser.vue
// module id = 1957
// module chunks = 0